import React, {useEffect, useState} from "react";
import {
  ConditionContainer,
  ConditionFormColumnWrapper,
  ConditionFormContainer, ConditionsActions,
  ConditionSummaryContainer
} from "./Condition.styled";
import { Header } from "../../components";
import FilterSelector from "../../../../../elements/v2/FilterSelector/FilterSelector";
import {RoundedButton} from "../../../../../elements";
import {Alert, AlertTitle} from "@mui/material";
import {
  CONTACT_FILTER_OPTIONS,
  CONVERSATION_TYPE_OPTIONS,
  SUPPRESSION_PERIOD_OPTIONS,
  TRIGGER_EVENT_OPTIONS
} from "./const";

const Condition = ({ onNext }) => {
  const [searchComplete, setSearchComplete] = useState(false);
  const [conversationType, setConversationType] = useState("");
  const [triggerEvent, setTriggerEvent] = useState("");
  const [suppressionPeriod, setSuppressionPeriod] = useState("");
  const [contactStatusFilter, setContactStatusFilter] = useState("");
  
  const onChangeConversationType = (value) => {
    setConversationType(value.target.value);
  };
  
  const onChangeTriggerEvent = (value) => {
    setTriggerEvent(value.target.value);
  }
  
  const onChangeSuppressionPeriod = (value) => {
    setSuppressionPeriod(value.target.value);
  }
  
  const onChangeContactStatusFilter = (value) => {
    setContactStatusFilter(value.target.value);
  }

  useEffect(() => {
    if (contactStatusFilter && triggerEvent && suppressionPeriod && conversationType) {
      setSearchComplete(true);
    } 
  }, [conversationType, triggerEvent, suppressionPeriod, contactStatusFilter]);
  
  return (
    <ConditionContainer>
      <Header
        title="Name Your Suppression Rule"
        description="Enter a clear rule name and an optional description to explain what this rule is for."
        textAlign="left"
        headerSize="14px"
      />
      <ConditionFormContainer>
        <ConditionFormColumnWrapper>
          <FilterSelector
            title="Conversation Type"
            data={CONVERSATION_TYPE_OPTIONS}
            minWidthForm={500}
            minWidthPaper={263}
            value={conversationType}
            type="single"
            handleChange={onChangeConversationType}
          />
          <FilterSelector
            title="Suppression Period"
            data={SUPPRESSION_PERIOD_OPTIONS}
            minWidthForm={500}
            minWidthPaper={263}
            value={suppressionPeriod}
            type="single"
            handleChange={onChangeSuppressionPeriod}
          />
        </ConditionFormColumnWrapper>
        <ConditionFormColumnWrapper>
          <FilterSelector
            title="Trigger Event"
            data={TRIGGER_EVENT_OPTIONS}
            minWidthForm={500}
            minWidthPaper={263}
            value={triggerEvent}
            type="single"
            handleChange={onChangeTriggerEvent}
          />
          <FilterSelector
            title="Contact Status Filter"
            data={CONTACT_FILTER_OPTIONS}
            minWidthForm={500}
            minWidthPaper={263}
            value={contactStatusFilter}
            type="single"
            handleChange={onChangeContactStatusFilter}
          />
        </ConditionFormColumnWrapper>
      </ConditionFormContainer>
      {searchComplete &&
        <>
          <Header
            title="Summary"
            description="This rule prevents contacting active contacts again via email within 2 days after a message is sent."
            textAlign="left"
            headerSize="14px"
          />
          <ConditionSummaryContainer>
            <Alert severity="warning">
              <AlertTitle>This rule would affect approximately 640 contacts.</AlertTitle>
              based on your comunication patterns over the last 30 days.
            </Alert>
          </ConditionSummaryContainer>
        </>
      }
      <ConditionsActions>
        <RoundedButton
          width="78px"
          height="40px"
          kind={"primary"}
          outline={true}
          fontWeight="normal"
          fontSize="14px"
          margin="0"
          borderRadius="8px"
          onClick={() => {}}
        >
          Cancel
        </RoundedButton>
        <RoundedButton
          width="64px"
          height="40px"
          kind={"confirm"}
          fontWeight="normal"
          fontSize="14px"
          margin="0"
          borderRadius="8px"
          onClick={onNext}
        >
          Next
        </RoundedButton>
      </ConditionsActions>
    </ConditionContainer>
  );
};

export default Condition; 